import { createFileRoute } from "@tanstack/react-router";
import OwnerSettingsPage from "@/pages/OwnerSettingsPage";

export const Route = createFileRoute("/_owner/owner/settings")({
  component: OwnerSettingsPage,
});
